import { ActionNode } from 'common/builder/components/chart/FlowChart/components/Node/Action/Action'
import { Comment } from 'common/builder/components/chart/FlowChart/components/Node/Comment/Comment'
import { ConditionNode } from 'common/builder/components/chart/FlowChart/components/Node/Condition/Condition'
import { ContentNode } from 'common/builder/components/chart/FlowChart/components/Node/Content/Content'
import { FallbackNode } from 'common/builder/components/chart/FlowChart/components/Node/Fallback/Fallback'
import { Goto } from 'common/builder/components/chart/FlowChart/components/Node/Goto/Goto'
import { SmartDelay } from 'common/builder/components/chart/FlowChart/components/Node/SmartDelay/SmartDelay'
import { Split } from 'common/builder/components/chart/FlowChart/components/Node/SplitNode/SplitNode'
import { StartingStep } from 'common/builder/components/chart/FlowChart/components/Node/StartingStep/StartingStep'
import { NodeComponent } from 'common/builder/components/chart/FlowChart/components/Node/types'
import { FlowChartNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNode'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'

export const NodeToCompontentMapping: Partial<
  Record<FlowChartNodeType, NodeComponent<FlowChartNode>>
> = {
  [FlowChartNodeType.CONTENT]: ContentNode as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.GOTO]: Goto as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.STARTING_STEP]: StartingStep as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.SMART_DELAY]: SmartDelay as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.SPLIT]: Split as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.COMMENT]: Comment as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.CONDITION]: ConditionNode as NodeComponent<FlowChartNode>,
  [FlowChartNodeType.ACTION]: ActionNode as NodeComponent<FlowChartNode>,
}

export const FallbackNodeComponent = FallbackNode
